import TimeLineItem from "./TimelineItem";
import InfoItem from "./InfoItem";
import EducationCard from "./EducationCard";

function ExperienceCerts({ experiences, certifications, languages }) {
  return (
    <section className="section" id="experience">
      <div className="two-col">
        <div>
          <div className="section-eyebrow">Career Journey</div>

          <h2 className="section-title" style={{ marginBottom: "2rem" }}>
            Experience
          </h2>

          <div className="timeline">
            {experiences.map((experience) => (
              <TimeLineItem
                key={`${experience.company}-${experience.period}`}
                {...experience}
              />
            ))}
          </div>
        </div>

        <div>
          <div className="section-eyebrow">Professional Development</div>

          <h2 className="section-title" style={{ marginBottom: "2rem" }}>
            Certifications
          </h2>

          <div className="cert-list">
            {certifications.map((certification) => (
              <InfoItem key={certification.name} {...certification} />
            ))}
          </div>

          <div style={{ marginTop: "2rem" }}>
            <div
              className="section-eyebrow"
              style={{ marginBottom: "0.75rem" }}
            >
              Languages
            </div>

            <div className="cert-list">
              {languages.map((language) => (
                <InfoItem key={language.name} {...language} />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "4rem" }}>
        <div className="section-eyebrow">Education</div>

        <h2 className="section-title" style={{ marginBottom: "2rem" }}>
          Academic Background
        </h2>

        <EducationCard />
      </div>
    </section>
  );
}

export default ExperienceCerts;
